import { Helmet } from "react-helmet";

// Рендерит один или несколько блоков schema.org разметки в <head>.
// data — объект или массив объектов JSON-LD (null/undefined отфильтровываются).
export default function JsonLd({ data }) {
  const items = (Array.isArray(data) ? data : [data]).filter(Boolean);
  if (!items.length) return null;

  return (
    <Helmet>
      {items.map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}
